import { defaultConfiguratorState } from "./types";

/** Shown when center design is “text” but the field is empty (matches initial state default). */
export const DEFAULT_CENTER_DISPLAY_TEXT = defaultConfiguratorState.centerText;

/** Perimeter “text lighting” when CPB inputs are empty (LED wall text). */
export const DEFAULT_LED_TEXT_LIGHTING_PLACEHOLDER = "Enter Text";

declare global {
  interface Window {
    __MAYTRIX_DEFAULT_LOGO_URL__?: string;
  }
}

const DEFAULT_LOGO_FILE = "upload-logo.png";

/**
 * Branded fallback when CPB has “logo” middle design but no upload.
 * Shopify: `snippets/3d-viewer.liquid` sets `window.__MAYTRIX_DEFAULT_LOGO_URL__`.
 * Otherwise we rewrite `viewer.js` in the bundle script URL to `{DEFAULT_LOGO_FILE}` (same assets folder).
 */
export function getDefaultCenterLogoUrl(): string {
  if (typeof window === "undefined") return "";
  const injected = window.__MAYTRIX_DEFAULT_LOGO_URL__?.trim();
  if (injected) return injected;
  try {
    const scripts = document.getElementsByTagName("script");
    for (let i = scripts.length - 1; i >= 0; i--) {
      const src = scripts[i].src;
      if (!src.includes("viewer.js")) continue;
      return src.replace(/viewer\.js([?#][^#]*)?$/i, `${DEFAULT_LOGO_FILE}$1`);
    }
  } catch {
    /* ignore */
  }
  return "";
}
